{
  "title": "Registration Data Column Reference",
  "description": "Column definitions and available filters on the Registration Data page, plus the \"Registrations that need an update\" block; the team list is a read-only view and never reflects eligibility status.",
  "headings": ["Column Reference", "Available Filters"],
  "intro": "The Registration Data page (under the \"Data\" nav group) lists every team's registration-form completion status and last-modified time; the team list below is for viewing only and offers no editing or review actions. Registration completion and eligibility status are two completely independent axes: the completion status shown here never reflects, and is never affected by, eligibility review outcomes. At the top of the page there is also a \"Registrations that need an update\" block: it lists students who completed registration but whose saved answers no longer meet the current published form (name, team and the fields still to fill in; no email address and no answers), and is hidden when nobody needs an update; people with team management permission can \"Send a test to myself\" or \"Send update reminder\" here (which first shows the count and an email preview, and only then emails that student themself). This page never fills in or changes any registration data for a student.",
  "submissionSectionHeading": "Column Reference",
  "submissionStatuses": [
    { "name": "Team", "editable": "The team's name." },
    { "name": "Leader", "editable": "The team leader's display name and email." },
    {
      "name": "Form Version",
      "editable": "The registration form version the team's answers were submitted against; shows \"No version\" if there's no recorded version yet."
    },
    {
      "name": "Completion Status",
      "editable": "Whether the registration form has been filled out completely — only a Complete or Incomplete badge."
    },
    {
      "name": "Last Modified",
      "editable": "The last time this team's registration data changed; shows \"—\" if there's no data yet."
    },
    {
      "name": "Actions",
      "editable": "Only a Complete team shows a \"View Answers\" button, which opens a read-only dialog with the team's full form answers, form version number, submission time, and last-updated time."
    }
  ],
  "judgeSectionHeading": "Available Filters",
  "judgeStatuses": [
    {
      "name": "Filter by completion status",
      "description": "Show only Complete or Incomplete teams."
    },
    { "name": "Filter by team ID", "description": "Filter by typing a team ID." },
    {
      "name": "Text search",
      "description": "Search by team or leader text; every filter is kept in the URL, so sharing the link or reloading the page preserves your query."
    }
  ]
}
